import type { ColDef, ColGroupDef } from 'ag-grid-community'
import { IGroupColumnsSelection } from 'features/RiskManagement/Components/Tables'

type MergedDef = ColDef | ColGroupDef

/**
 * Update column definition to reflect group/configure columns configuration
 *
 * WARN: This function may not be able to handle nested colDefs properly
 *       due to the fact that the `colDefs` parameter passed in may not have
 *       child nodes/colDefs specified at location expected by `ColGroupDef`.
 *       However, SSRM implemenation should bypass this implementation detail
 *       so this function may not be needed at all.
 *
 * @param colDefs - might not be a proper ColDef!
 * @param groupColumns
 * @param level - header nesting depth
 * @returns modified colDefs that follows group columns specification
 */
export const applyGroupColumnsSettingToColDefs = (
  colDefs: MergedDef[],
  groupColumns: IGroupColumnsSelection[],
  level: number
): Array<ColDef> => {
  const columnConfiguration = groupColumns[level]

  if (columnConfiguration == null) {
    console.error(`Missing column configuration for nesting level ${level}!`)

    return colDefs
  }

  // NOTE: temp workaround to work with old structure
  const attributesToShow =
    columnConfiguration.groupTypeColumns == null
      ? colDefs.map((cd: ColDef) => String(cd.field))
      : columnConfiguration.groupTypeColumns

  const newColDefList = []

  for (const attrName of attributesToShow) {
    // NOTE: temp workaround to work with old structure
    const colDef = colDefs.find((cd: ColDef) => cd.field === attrName)

    if (colDef != null) {
      // REVIEW: This may not work due to it being table object instead of proper ColDefs
      if ('children' in colDef) {
        colDef.children = applyGroupColumnsSettingToColDefs(
          colDef.children,
          groupColumns,
          level + 1
        )
      }

      newColDefList.push(colDef)
    }
  }

  return newColDefList
}
